module.exports = __webpack_public_path__ + "img/25_explorer.de06cf85.png";